import { TimePicker } from './timepicker';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'ng2-select';
import { TypeaheadModule } from 'ng2-bootstrap/typeahead';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { EntitySelect } from './selectentity';
import { CascadedLookup } from './cascadedlookup';
import { EntityRecordSelectMultiple } from './selectentityrecord-multiple';
import { EntityRecordSelect } from './selectentityrecord';
import { RecordSelect } from './selectrecord';
import { RepeatComponent } from './repeatedsection';
import { EntityfieldSelect } from './selectentityfield';
import { PicklistSelect } from './selectpicklist';
import { PicklistLookup } from './lookuppicklist';
import { PicklistRadio } from './radiopicklist';
import { DatePicker } from './datepicker';
import { ToggleCheckbox } from './toggle';
import { ReadonlyField } from './readonlyfield';
import { EntitySelectMultiple } from './selectentity-multiple';
import { EntityfieldMultipleSelect } from './selectentityfield-multiple';
import { DataElementSelect } from './selectdataelement';
import { UserSelect } from './selectuser';
import { DateRangePicker } from './daterangepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from 'ng-formly';
import { InputField } from './inputfield';
import { FilterSelect } from './selectfilter';
import { PagelayoutSelect } from './selectpagelayout';
import { SearchlayoutSelect } from './selectsearchlayout';
import { TextAreaField } from './textareafield';
import { OptionSelect } from './selectoptions';
import { OptionSelectMultiple } from './selectoptions-multiple';
import { ComponentSelect } from './selectcomponent';
import { ComponentSelectMultiple } from './selectcomponent-multiple';
import { TypeaheadComponent } from './typeahead';
import { SubEntity } from './subentity';

import {
  PreviousActivitiesWidgetComponent,
  NextStepsWidgetComponent,
  ActivityWidgetComponent,
  ActivityScrollComponent,
  GridListWidgetComponent,
  // GridButtonsComponent,
  // MetricTargetWidgetComponent,
  BarchartWidgetComponent,
  EntityDisplayWidgetComponent,
  EntityRecordEditButtonComponent,
  EntityAddButtonComponent,
  EntityFieldEditableComponent,
  FilterDisplayComponent,
  FilterButtonComponent,
  // LineChartComponent,
  MetricWidgetComponent,
  // PieChartComponent,
  TableWidgetComponent,
  // TableDisplayComponent,
  // AngularGaugeComponent,
  // EventsChartComponent,
  // EmailButtonComponent,
  NotesDisplayComponent,
  NotesTextBoxComponent,
  UserListComponent,
  ChartComponent
  // ProfilePhotoComponent
} from '../widgets';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    SelectModule,
    MyDateRangePickerModule,
    TypeaheadModule.forRoot()
  ],


  declarations: [
    DataElementSelect,
    DatePicker,
    DateRangePicker,
    EntityfieldMultipleSelect,
    EntityfieldSelect,
    CascadedLookup,
    EntityRecordSelectMultiple,
    EntityRecordSelect,
    RecordSelect,
    EntitySelect,
    EntitySelectMultiple,
    InputField,
    FilterSelect,
    PagelayoutSelect,
    PicklistLookup,
    PicklistRadio,
    PicklistSelect,
    ReadonlyField,
    RepeatComponent,
    OptionSelect,
    OptionSelectMultiple,
    ComponentSelect,
    ComponentSelectMultiple,
    SearchlayoutSelect,
    SubEntity,
    TextAreaField,
    TimePicker,
    ToggleCheckbox,
    UserSelect,
    TypeaheadComponent
  ],

  exports: [
    DataElementSelect,
    DatePicker,
    DateRangePicker,
    EntityfieldMultipleSelect,
    EntityfieldSelect,
    CascadedLookup,
    EntityRecordSelectMultiple,
    EntityRecordSelect,
    RecordSelect,
    EntitySelect,
    EntitySelectMultiple,
    InputField,
    FilterSelect,
    PagelayoutSelect,
    PicklistLookup,
    PicklistRadio,
    PicklistSelect,
    ReadonlyField,
    RepeatComponent,
    OptionSelect,
    OptionSelectMultiple,
    ComponentSelect,
    ComponentSelectMultiple,
    SearchlayoutSelect,
    SubEntity,
    TextAreaField,
    TimePicker,
    ToggleCheckbox,
    UserSelect,
    TypeaheadComponent
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class CustomFieldsModule { }


// WEBPACK FOOTER //
// ./src/app/shared/components/fields/fields.module.ts